export const FIT_BANDS = {
  HIGHLY: {
    label: "Highly Recommended",
    dnaLabel: "Star",
    color: "#61C489",
    textColor: "#2C6740",
    description: "This pool represents the top performers for this role",
  },
  RECOMMENDED: {
    label: "Recommended",
    dnaLabel: "High",
    color: "#ABE99B",
    textColor: "#25581B",
    description: "This pool represents people above industry average",
  },
  CAUTIOUSLY: {
    label: "Cautiously recommended",
    dnaLabel: "Medium",
    color: "#FFDB8F",
    textColor: "#775100",
    description:
      "This pool represents people below industry average (but in the acceptable band)",
  },
  NOT: {
    label: "Not recommended",
    dnaLabel: "Low",
    color: "#FE9EAB",
    textColor: "#71000F",
    description: "This pool represents the bottom performers for this role",
  }
};

// Not included in FIT_BANDS -> Since being mapped in many comps
export const DISQUALIFIED_BAND = {
  label: "Disqualified",
  dnaLabel: "",
  color: "#F3F3F3",
  textColor: "##13434",
  description: "",
};

export const QUIZ_DISPLAY_SECTIONS = {
  MCQ: "mcq",
  PROGRAMMING: "programming",
  CHAT: "chat"
};

export const TEST_CASE_STATUS = {
  PASS: "pass",
  FAIL: "fail"
};

export const TEST_CASE_TABLE_HEADER = [
  "Input",
  "Expected",
  "Actual",
  "Result",
  "Time (s)",
  "Memory (KB)",
  "Score",
];

export const NO_OUTPUT_PLACEHOLDER = "No output";

export const TEST_CASE_HEADER_PLACEHOLDER = [
  { heading: 'Time', value: null },
  { heading: 'Memory', value: null },
  { heading: 'Language', value: null },
  { heading: 'Test Cases', value: null }
];

export const QUESTIONS = {
  CHAT: "chat",
  SPEECH: "speech",
  SENTENCE_COMPLETION: "sentence_completion",
  TYPING_TEXT: "typing_text",
  FREE_TEXT: "free_text",
  SPEECH_SCRIPT: "speech_scripted",
  SPEECH_SPONTANEOUS: "speech_spontaneous"
};

export const VIDEO_SKIP = {
  ACTIONS: {
    FORWARD: "forward",
    BACKWARD: "backward"
  },
  SKIP_VAL: 10,
  CLIP_LENGTH: 5,
}

export const CEFR_MAP = {
  get: (score) => {
    score = Number(score)
    if (score > 0.92) return "C2"
    if (score > 0.84) return "C1"
    if (score > 0.80) return "B2+"
    if (score > 0.75) return "B2"
    if (score > 0.68) return "B1+"
    if (score > 0.60) return "B1"
    if (score > 0.40) return "A2"
    if (score > 0.0) return "A1"
    return "NA"
  }
}

export const AI_PROCTORING = {
  TYPES: {
    CHEATING: "cheating",
    MAYBECHEATING: "maybeCheating",
    NOTCHEATING: "notCheating",
  },
}

export const languageOptions = {
  "en": "English",
  "hi": "Hindi",
  "bn": "Bangla",
  "kn": "Kannada",
  "pa": "Punjabi",
  "ta": "Tamil",
  "te": "Telugu",
  "gu": "Gujarati",
  "mr": "Marathi",
  "ar": "Arabic"
}

export const HIDE_DOWNLOAD_REPORT_ORGS = ["d76e7d03-df23-4e11-bf58-06a489299c2b"
  // , "55d87803-f999-4329-af74-f6d3dbe56f61"
]

export const PLAGIARISM_BREAKDOWN_LABELS = {
  "ast": "Code Structure",
  "lexical": "Naming & Conventions",
  "token": "Code Tokens",
  "semantic": "Core Logic",
}

export const HIDE_EMAIL_FOR_LINK_IDS = {
  "95a4b4e0-77aa-42b6-b508-e6ad2f71c5fe": true,
  "df4d8937-924f-4f7b-b57b-7f01302ec85f": true,
  "dcc1a689-f741-4c95-a89b-39ae3305b186": true,
}